/**
 * @generated SignedSource<<7264374704924e81114dcc016eeab628>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type leaveUserNameQuery$variables = Record<PropertyKey, never>;
export type leaveUserNameQuery$data = {
  readonly bznavRefund: {
    readonly user: {
      readonly name: string | null | undefined;
    };
  };
};
export type leaveUserNameQuery = {
  response: leaveUserNameQuery$data;
  variables: leaveUserNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BznavRefundOutput",
    "kind": "LinkedField",
    "name": "bznavRefund",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RefundUserType",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "leaveUserNameQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "leaveUserNameQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f08a5ee4245552f6983f1f1d9848bf2e",
    "id": null,
    "metadata": {},
    "name": "leaveUserNameQuery",
    "operationKind": "query",
    "text": "query leaveUserNameQuery {\n  bznavRefund {\n    user {\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6086b7819a5f37383a5f57775a262b68";

export default node;
